// extracted by mini-css-extract-plugin
module.exports = {"stores-video-container":"_33tzd4N7","storesVideoContainer":"_33tzd4N7"};